import { MenuItem, SelectField } from 'material-ui';
import React from 'react';
import config from 'cfg';
import _ from 'lodash';
import Promise from 'bluebird';
import * as rmd from 'material-ui';

class IncidentPicker extends React.Component {
    constructor(props, context) {
        super(props, context);
        const { incidentId, eventId } = props;
        this.state = {
            incidentId: Number(incidentId),
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        const { eventId } = nextProps;
        if (eventId !== this.props.eventId) {
            this.setState({ event: null }, () => {
                this.loadData();
            });
        }
    }

    loadData() {
        const { eventId } = this.props;
        if (!eventId) return;

        return Promise.props({
            event: fetch(`${config.apis.ss2}/events/${eventId}`),
        })
            .then(result => {
                return Promise.props({
                    event: result.event.status === 200 && result.event.json(),
                });
            })
            .then(res => {
                this.setState({ event: res.event });
            });
    }

    renderOption(option) {
        return (
            <MenuItem
                key={option.incidentId}
                value={option.incidentId}
                primaryText={`${option.type} - ${option.participantName}`}
                secondaryText={option.min + "'"}
            />
        );
    }

    handleRoundChange = (e, k, val) => {
        const key = this.props.propKey || 'incidentId';
        const incidentId = Number(val);
        if (this.props.onChange) {
            this.props.onChange(key, incidentId);
        }
        this.setState({ incidentId });
    };

    render() {
        const incidents = _.get(this.state, 'event.incidents', []);
        const { filter } = this.props;

        return (
            <div>
                <SelectField
                    floatingLabelText={this.props.label || 'Incident'}
                    floatingLabelFixed={incidents.length > 0}
                    value={this.state.incidentId}
                    style={{ width: '100%' }}
                    disabled={incidents.length === 0}
                    onChange={this.handleRoundChange}
                >
                    {_.filter(incidents, i => {
                        return filter ? filter.includes(i.typeId) : true;
                    }).map(this.renderOption)}
                </SelectField>
            </div>
        );
    }
}

export default IncidentPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/IncidentPicker.js
 **/